module.exports = __webpack_public_path__ + "img/86.3c66afdf.jpg";